var features;

features = function(action) {
  var $, Swiper;
  Swiper = require('swiper');
  return $ = require('jquery');
};

module.exports = features;
